export function setLoading (state, payload) {
  state.isLoading = payload
}

export function setIsOnline (state, payload) {
  state.isOnline = payload
}
